module.exports = __webpack_public_path__ + "static/media/wallet.58a86830.svg";